import type { Category, NewsArticle } from '@/types/news';

export const categories: Category[] = [
  {
    id: 'society',
    name: '社会热点',
    slug: 'society',
    intro: '聚焦民生关切与社会治理，第一时间直击城市、交通、医疗等公共领域的重要变化。',
    description: '爆料网社会热点频道，汇集城市治理、公共交通、医疗保障、乡村振兴等权威新闻爆料与深度事件解析。',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20news%20photograph%20of%20a%20bustling%20modern%20city%20street%20with%20commuters%20and%20glass%20office%20buildings%2C%20soft%20morning%20light%2C%20clean%20documentary%20composition%2C%20muted%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=cat-society-cover&orientation=landscape',
  },
  {
    id: 'entertainment',
    name: '娱乐资讯',
    slug: 'entertainment',
    intro: '影视、音乐、综艺、演出一网打尽，追踪台前幕后的真实动态与口碑风向。',
    description: '爆料网娱乐资讯频道，覆盖影视剧集、音乐盛典、综艺节目与演唱会的最新爆料与深度解读。',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20glowing%20theater%20stage%20with%20warm%20spotlights%20and%20empty%20red%20seats%2C%20cinematic%20atmosphere%2C%20clean%20documentary%20composition%2C%20muted%20tones%2C%20high%20detail&width=1200&height=800&seq=cat-ent-cover&orientation=landscape',
  },
  {
    id: 'life',
    name: '生活动态',
    slug: 'life',
    intro: '健康、消费、出行、教育、饮食，帮你把日常生活的每件小事都安排明白。',
    description: '爆料网生活动态频道，提供健康养生、消费提醒、旅游出行、教育服务与食品安全等实用资讯。',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20lifestyle%20photograph%20of%20a%20bright%20cozy%20home%20interior%20with%20plants%20coffee%20and%20open%20notebook%2C%20soft%20daylight%2C%20clean%20documentary%20composition%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=cat-life-cover&orientation=landscape',
  },
];

export const newsList: NewsArticle[] = [
  {
    id: 'society-001',
    title: '多地轨道交通新线今日同步开通，城市通勤圈再扩容',
    summary:
      '今日上午，全国多个城市轨道交通新线集中开通运营，新增运营里程超过三百公里，主城区与周边新城的通勤时间平均缩短约二十分钟。',
    category: 'society',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20news%20photograph%20of%20a%20modern%20subway%20station%20platform%20with%20clean%20lines%20and%20waiting%20passengers%2C%20soft%20artificial%20light%2C%20documentary%20composition%2C%20muted%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=news-society-001&orientation=landscape',
    author: '本报记者 林清',
    source: '爆料网社会部',
    publishTime: '2026-10-12 09:20',
    views: 128400,
    tags: ['轨道交通', '城市交通', '民生'],
    hot: true,
    content: [
      '今日上午，全国多个城市轨道交通新线集中开通运营。据不完全统计，本次集中开通的线路新增运营里程超过三百公里，覆盖主城区、产业新城与交通枢纽等多个关键节点，被业内视为今年城市公共交通领域最重要的一次扩容。',
      '记者在现场看到，新开通站点普遍采用了更大空间的站厅设计与智能导向系统，乘客可通过电子屏实时查询换乘路径与车厢拥挤度。多位受访市民表示，新线路开通后，从居住地到工作地的通勤时间平均缩短了约二十分钟，早晚高峰的换乘压力得到明显缓解。',
      '有关部门负责人介绍，本轮新线建设在规划阶段就重点考虑了大客流走廊的疏解需求，并预留了与周边城际铁路、公交枢纽的接驳条件。下一步将同步优化地面公交线路，逐步形成以轨道交通为骨干、公交为基础的立体化出行网络。',
      '业内专家表示，轨道交通网络的加密不仅能改善通勤体验，也将进一步带动沿线商业与住宅板块的发展，对城市空间结构的优化具有长远意义。',
    ],
  },
  {
    id: 'society-002',
    title: '中央气象台发布暴雨橙色预警，多地启动应急响应',
    summary:
      '受强对流天气影响，未来三天南方多地将出现强降雨过程，部分地区伴有雷暴大风，多地已启动防汛应急响应并提示公众减少外出。',
    category: 'society',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20weather%20news%20photograph%20of%20dark%20storm%20clouds%20over%20a%20city%20skyline%20with%20rain%20streaks%2C%20moody%20overcast%20light%2C%20documentary%20composition%2C%20muted%20tones%2C%20high%20detail&width=1200&height=800&seq=news-society-002&orientation=landscape',
    author: '本报记者 周雨',
    source: '爆料网社会部',
    publishTime: '2026-10-12 08:05',
    views: 96200,
    tags: ['天气预警', '防汛', '民生'],
    hot: true,
    content: [
      '中央气象台今日发布暴雨橙色预警，预计未来三天南方多地将出现一次明显的强降雨过程，局地累计雨量可能突破历史同期极值，并伴有短时强降水、雷暴大风等强对流天气。',
      '预警发布后，多地迅速启动防汛应急响应，对水库、河道、地质灾害隐患点开展拉网式排查，并提前转移安置受威胁区域的群众。部分城市临时关闭了低洼地段的道路与地下通道，公交、地铁运营单位也加强了巡查值守。',
      '气象部门提醒，强降雨期间公众应尽量减少外出，避免前往山洪、滑坡等次生灾害易发区域；驾车出行需留意路面积水，切勿强行通过深水路段。相关部门也已通过短信、广播等渠道向受影响区域滚动发布提示信息。',
      '截至发稿，各地抢险救援力量已进入待命状态，重点保障供电、供水、通信等城市生命线的正常运行。',
    ],
  },
  {
    id: 'society-003',
    title: '新版国家医保药品目录落地，百余种新药纳入报销范围',
    summary:
      '新版国家医保药品目录正式实施，新增百余种药品，覆盖肿瘤、慢性病、罕见病等多个领域，相关患者用药负担将进一步减轻。',
    category: 'society',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20health%20news%20photograph%20of%20a%20bright%20hospital%20pharmacy%20shelf%20with%20neatly%20arranged%20medicine%20boxes%2C%20clean%20clinical%20light%2C%20documentary%20composition%2C%20soft%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=news-society-003&orientation=landscape',
    author: '本报记者 陈立',
    source: '爆料网民生观察',
    publishTime: '2026-10-11 16:40',
    views: 73500,
    tags: ['医保', '医疗', '民生'],
    hot: false,
    content: [
      '新版国家医保药品目录于本月正式实施，本次调整新增纳入百余种药品，涵盖肿瘤靶向治疗、慢性病长期用药、罕见病特效药以及儿童用药等多个领域，目录内药品总数进一步扩大。',
      '据相关部门介绍，本轮调整在谈判环节坚持“以量换价”，多数新纳入药品价格出现明显下降，部分罕见病用药的年治疗费用降幅超过一半。对需要长期服药的患者而言，报销范围的扩大将实实在在减轻家庭负担。',
      '多家定点医疗机构表示，已同步完成药品配备与医保系统更新，参保患者在门诊或住院结算时可直接享受报销待遇。医保部门还开通了咨询热线，方便群众查询具体药品的报销比例与适用范围。',
      '专家指出，医保目录的动态调整正逐步形成“有进有出”的常态化机制，既保障了创新药的可及性，也兼顾了基金运行的可持续性。',
    ],
  },
  {
    id: 'society-004',
    title: '老旧小区改造提速，加装电梯与适老化设施成重点',
    summary:
      '今年多地老旧小区改造进入集中施工期，加装电梯、无障碍通道、适老化设施等成为改造重点，惠及数十万户居民。',
    category: 'society',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20news%20photograph%20of%20a%20renovated%20residential%20neighborhood%20courtyard%20with%20green%20trees%20and%20elderly%20walking%2C%20soft%20afternoon%20light%2C%20documentary%20composition%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=news-society-004&orientation=landscape',
    author: '本报记者 王禾',
    source: '爆料网社会部',
    publishTime: '2026-10-11 11:15',
    views: 51200,
    tags: ['城市更新', '老旧小区', '民生'],
    hot: false,
    content: [
      '今年以来，多地老旧小区改造进入集中施工期。与以往“刷墙铺路”不同，本轮改造更强调功能提升，加装电梯、无障碍通道、适老化设施以及停车与充电配套成为重点内容。',
      '记者走访多个改造现场看到，施工方在方案设计阶段广泛征求居民意见，针对高层住户出行难、老年居民活动空间不足等问题逐一给出解决方案。部分小区还利用闲置边角地建起了口袋公园与健身角。',
      '有关部门表示，本轮改造惠及居民数十万户，并同步建立了后续管护机制，避免“改完就乱”。通过引入物业或社区自治组织，改造后的公共设施能够得到长期维护。',
      '居民们普遍反映，改造后的小区不仅更整洁，生活便利度也明显提高，邻里之间的交流也随之增多。',
    ],
  },
  {
    id: 'society-005',
    title: '数字技术赋能乡村振兴，农产品直播走上快车道',
    summary:
      '随着数字基础设施下沉，越来越多乡村搭上直播电商快车，特色农产品通过线上渠道走向全国，带动农户增收。',
    category: 'society',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20news%20photograph%20of%20a%20farmer%20live%20streaming%20fresh%20produce%20in%20a%20sunlit%20field%20with%20smartphone%20tripod%2C%20warm%20natural%20light%2C%20documentary%20composition%2C%20muted%20tones%2C%20high%20detail&width=1200&height=800&seq=news-society-005&orientation=landscape',
    author: '本报记者 赵然',
    source: '爆料网乡村振兴栏目',
    publishTime: '2026-10-10 14:30',
    views: 44800,
    tags: ['乡村振兴', '电商', '数字技术'],
    hot: false,
    content: [
      '随着网络与物流基础设施不断下沉，数字技术正加速赋能乡村产业。记者在多个县域走访发现，直播电商已成为特色农产品走出大山的重要通道。',
      '在田间地头，农户们架起手机进行直播，把刚采摘的果蔬、手工制作的农副产品直接展示给屏幕另一端的消费者。相比传统批发渠道，线上直销减少了中间环节，农户的收益空间明显扩大。',
      '为帮助农户掌握运营技能，多地还组织开展了短视频拍摄、账号运营、供应链管理等培训，并建设了县级电商服务中心，提供仓储、分拣、冷链等配套支持。',
      '业内专家认为，数字技术只是工具，关键还在于打造稳定的产品标准与品牌口碑，只有品质过硬，乡村产业才能走得更远更稳。',
    ],
  },
  {
    id: 'society-006',
    title: '全国反诈专项行动成效显著，涉诈案件同比下降',
    summary:
      '今年以来，全国公安机关持续推进打击治理电信网络诈骗专项行动，涉诈案件数量同比明显下降，群众防骗意识不断提升。',
    category: 'society',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20news%20photograph%20of%20a%20public%20security%20service%20counter%20with%20officers%20explaining%20anti%20fraud%20posters%20to%20residents%2C%20clean%20indoor%20light%2C%20documentary%20composition%2C%20muted%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=news-society-006&orientation=landscape',
    author: '本报记者 郭明',
    source: '爆料网社会部',
    publishTime: '2026-10-10 09:00',
    views: 62900,
    tags: ['反诈', '公共安全', '民生'],
    hot: false,
    content: [
      '今年以来，全国公安机关持续推进打击治理电信网络诈骗专项行动，依托大数据研判与跨区域协作，对涉诈犯罪的打击力度不断加大，涉诈案件数量同比明显下降。',
      '在技术层面，相关部门加强了对涉诈电话、短信、网址的拦截与预警，并通过银行、支付机构联动，对可疑转账进行实时提醒和劝阻，帮助不少群众避免了资金损失。',
      '与此同时，社区、学校、企业广泛开展反诈宣传，把防骗知识送到群众身边。多地还上线了反诈小程序，用户可一键举报可疑线索，形成全民参与、群防群治的格局。',
      '公安部门提醒，公众要牢记“不听、不信、不转账”，凡涉及网络刷单、虚假投资、冒充客服退款等情形，都应提高警惕，及时通过官方渠道核实。',
    ],
  },
  {
    id: 'entertainment-001',
    title: '第XX届国际电影节开幕，多部华语影片入围主竞赛单元',
    summary:
      '第XX届国际电影节正式开幕，多部华语影片入围主竞赛单元，题材涵盖现实题材、文艺片与类型探索，引发广泛关注。',
    category: 'entertainment',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20grand%20film%20festival%20red%20carpet%20entrance%20at%20dusk%20with%20glowing%20lights%2C%20cinematic%20atmosphere%2C%20clean%20composition%2C%20muted%20warm%20tones%2C%20high%20detail&width=1200&height=800&seq=news-ent-001&orientation=landscape',
    author: '本报记者 苏晴',
    source: '爆料网文娱部',
    publishTime: '2026-10-12 10:10',
    views: 108600,
    tags: ['电影节', '华语电影', '影视'],
    hot: true,
    content: [
      '第XX届国际电影节正式开幕，来自全球的数百部影片将在为期十天的展映中集中亮相。本届电影节主竞赛单元的入围名单格外引人关注，多部华语影片成功入围，题材涵盖现实题材、文艺片与类型探索。',
      '据组委会介绍，本届电影节在选片思路上更加重视作品的作者表达与时代关切，同时保留了面向大众的类型片单元。开幕式上，多部入围影片的主创团队集体亮相，与观众分享了创作背后的故事。',
      '除了竞赛与展映，电影节还设置了论坛、创投、大师班等环节，为青年电影人提供交流平台。多位业内人士表示，电影节不仅是展示作品的舞台，也是观察行业风向的重要窗口。',
      '本届电影节将持续至本月下旬，多部展映影片在开票后迅速售罄，显示出观众对优质电影内容的持续热情。',
    ],
  },
  {
    id: 'entertainment-002',
    title: '国产悬疑剧《迷雾之城》口碑走高，现实题材再受关注',
    summary:
      '国产悬疑剧《迷雾之城》开播以来口碑持续走高，紧凑剧情与扎实表演获观众好评，现实题材创作再度成为讨论焦点。',
    category: 'entertainment',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20moody%20cinematic%20city%20street%20at%20night%20with%20neon%20reflections%20and%20fog%2C%20film%20noir%20atmosphere%2C%20clean%20composition%2C%20muted%20cool%20tones%2C%20high%20detail&width=1200&height=800&seq=news-ent-002&orientation=landscape',
    author: '本报记者 何晓',
    source: '爆料网文娱部',
    publishTime: '2026-10-11 20:00',
    views: 87300,
    tags: ['悬疑剧', '电视剧', '影视'],
    hot: true,
    content: [
      '国产悬疑剧《迷雾之城》开播以来口碑持续走高，凭借紧凑的叙事节奏、层层递进的悬念设置以及演员扎实的表演，迅速在社交平台引发讨论，不少观众自发梳理剧情线索。',
      '与部分重悬念、轻人物的同类作品不同，《迷雾之城》在小镇谜案的外壳之下，着力刻画普通人在选择与困境中的挣扎，让故事在紧张之余多了一层人文温度。',
      '多位剧评人指出，该剧的成功再次说明，现实题材与类型化表达并不矛盾。只要扎根生活、尊重观众智商，类型剧同样能够承载有分量的社会思考。',
      '制作方透露，团队在前期进行了大量实地采风，力求在细节上贴近真实。目前该剧仍在热播中，后续剧情走向成为观众关注的焦点。',
    ],
  },
  {
    id: 'entertainment-003',
    title: '年度音乐盛典落幕，多组音乐人同台献唱',
    summary:
      '年度音乐盛典日前圆满落幕，多组音乐人带来精彩舞台，原创作品与经典改编同台呈现，现场气氛热烈。',
    category: 'entertainment',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20concert%20stage%20with%20warm%20amber%20lights%20and%20silhouette%20of%20a%20singer%20holding%20microphone%2C%20energetic%20atmosphere%2C%20clean%20composition%2C%20muted%20tones%2C%20high%20detail&width=1200&height=800&seq=news-ent-003&orientation=landscape',
    author: '本报记者 罗一',
    source: '爆料网文娱部',
    publishTime: '2026-10-11 13:20',
    views: 65400,
    tags: ['音乐盛典', '演唱会', '音乐'],
    hot: false,
    content: [
      '年度音乐盛典日前圆满落幕，多组音乐人轮番登台，为现场与线上观众带来一场兼具流行与质感的声音盛宴。当晚舞台上，原创作品与经典改编交替呈现，气氛几度被推向高潮。',
      '本届盛典在舞台设计上颇费心思，以环绕式灯光与多媒体影像营造出沉浸感，让不同风格的作品都能找到契合的表达方式。多位歌手还带来了新专辑中的首发曲目。',
      '除了演出本身，盛典还设置了幕后花絮与创作者访谈环节，让观众更直观地了解一首歌从灵感到成型的全过程。',
      '主办方表示，希望通过这样的平台，让更多优秀的原创音乐被听见，也为音乐人与听众之间搭建更近距离的交流桥梁。',
    ],
  },
  {
    id: 'entertainment-004',
    title: '户外真人秀回归，真实体验与轻喜剧风格获好评',
    summary:
      '多档户外真人秀近期集中上线，主打真实体验与轻喜剧风格，去剧本化的呈现方式收获不少观众好评。',
    category: 'entertainment',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20group%20of%20friends%20laughing%20around%20a%20campfire%20in%20the%20outdoors%20at%20dusk%2C%20warm%20natural%20light%2C%20candid%20documentary%20composition%2C%20muted%20tones%2C%20high%20detail&width=1200&height=800&seq=news-ent-004&orientation=landscape',
    author: '本报记者 于恬',
    source: '爆料网综艺观察',
    publishTime: '2026-10-10 18:45',
    views: 48900,
    tags: ['真人秀', '综艺', '影视'],
    hot: false,
    content: [
      '多档户外真人秀近期集中上线，与棚内综艺相比，这批节目更强调真实场景与自然互动，主打“去剧本化”的呈现方式，嘉宾在旅途与协作中的真实反应成为最大看点。',
      '从已播出的内容看，节目组有意弱化竞技对抗，把更多篇幅留给生活化的细节。嘉宾们在完成任务时状况百出，笑点自然流露，不少片段在社交平台被反复转发。',
      '有观众表示，看惯了高强度对抗的综艺，这类节奏舒缓、氛围轻松的节目反而更治愈。也有评论指出，真实体验的背后同样需要精巧的内容设计，才能让节目既好看又不失真诚。',
      '业内人士认为，综艺市场正从“拼明星、拼话题”转向“拼内容、拼质感”，谁能更好地捕捉真实情绪，谁就更容易赢得观众。',
    ],
  },
  {
    id: 'entertainment-005',
    title: '国产动画电影票房亮眼，合家欢题材持续升温',
    summary:
      '多部国产动画电影近期票房表现亮眼，合家欢题材受到市场青睐，技术水准与故事表达同步提升。',
    category: 'entertainment',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20colorful%20animated%20movie%20poster%20wall%20in%20a%20cinema%20lobby%20with%20warm%20ambient%20light%2C%20clean%20composition%2C%20soft%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=news-ent-005&orientation=landscape',
    author: '本报记者 沈意',
    source: '爆料网文娱部',
    publishTime: '2026-10-10 11:00',
    views: 55300,
    tags: ['动画电影', '合家欢', '影视'],
    hot: false,
    content: [
      '近期多部国产动画电影在票房上表现亮眼，合家欢题材尤其受到市场青睐。节假日期间，不少家庭把观影作为共同的休闲选择，带动动画影片排片与上座率稳步走高。',
      '从内容看，这批作品在技术水准上进步明显，画面质感、动作设计都有长足提升；与此同时，创作者也更加注重故事的完整性与情感表达，力求让不同年龄段的观众都能有所共鸣。',
      '有院线人士表示，合家欢动画的稳定输出有助于丰富档期供给，也为国产动画积累了宝贵的市场经验。观众的口碑反馈，正成为影片能否走长线的重要变量。',
      '业内期待，随着工业化能力不断增强，国产动画能在题材与表达上持续突破，讲出更多属于自己的好故事。',
    ],
  },
  {
    id: 'entertainment-006',
    title: '巡回演唱会一票难求，演出市场热度不减',
    summary:
      '多场巡回演唱会门票开售即被抢空，演出市场热度持续，主办方加开场次以回应观众需求。',
    category: 'entertainment',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20packed%20concert%20arena%20with%20thousands%20of%20light%20sticks%20glowing%20in%20the%20dark%2C%20energetic%20atmosphere%2C%20clean%20composition%2C%20muted%20cool%20tones%2C%20high%20detail&width=1200&height=800&seq=news-ent-006&orientation=landscape',
    author: '本报记者 陆遥',
    source: '爆料网演出频道',
    publishTime: '2026-10-09 19:30',
    views: 71200,
    tags: ['演唱会', '演出', '音乐'],
    hot: false,
    content: [
      '今年以来，演出市场热度持续攀升，多场巡回演唱会门票开售即被抢空，部分热门城市甚至出现“一票难求”的场面。为回应观众需求，主办方陆续加开场次并升级场馆配置。',
      '记者了解到，本轮巡演在舞台制作上投入不菲，灯光、音响与视觉设计均有大幅升级，不少歌手还结合城市特色调整曲目编排，让每场演出都带有专属记忆点。',
      '演出升温也带动了周边餐饮、住宿与交通消费。有城市在演出期间延长公共交通运营时间，并推出观演指引，方便外地观众出行。',
      '业内人士提醒，观众应通过官方渠道购票，谨防“低价票”“内部票”等骗局，理性安排观演行程。',
    ],
  },
  {
    id: 'life-001',
    title: '秋冬流感高发期来临，这份预防指南请收好',
    summary:
      '随着气温下降，流感等呼吸道疾病进入高发期。专家提醒公众注意保暖、勤通风、按时接种疫苗，并养成良好卫生习惯。',
    category: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20lifestyle%20photograph%20of%20a%20cozy%20autumn%20scene%20with%20warm%20knitwear%20tea%20and%20autumn%20leaves%20on%20a%20wooden%20table%2C%20soft%20daylight%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=news-life-001&orientation=landscape',
    author: '本报记者 白露',
    source: '爆料网健康生活',
    publishTime: '2026-10-12 07:30',
    views: 58200,
    tags: ['健康', '流感预防', '生活'],
    hot: true,
    content: [
      '随着气温逐步下降，流感等呼吸道疾病进入一年中的高发期。多家医院的门诊数据显示，近期呼吸道感染就诊人数有所上升，其中以儿童与老年人居多。',
      '专家建议，公众应及时接种流感疫苗，尤其是老人、儿童、慢性病患者等重点人群。日常生活中要注意保暖，随气温变化增减衣物，室内常通风换气，保持空气流通。',
      '此外，勤洗手、少去人群密集的封闭场所、外出佩戴口罩等良好卫生习惯，能够有效降低感染风险。若出现持续高热、呼吸困难等症状，应尽早就医，避免自行用药延误病情。',
      '专家同时提醒，均衡饮食、规律作息、适度锻炼有助于增强免疫力，是预防疾病最基础也最有效的方式。',
    ],
  },
  {
    id: 'life-002',
    title: '消费旺季将至，多部门发布购物防坑提醒',
    summary:
      '随着消费旺季临近，多部门联合发布消费提示，提醒消费者警惕先涨后降、虚假宣传等套路，理性购物并保留凭证。',
    category: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20lifestyle%20photograph%20of%20a%20person%20shopping%20online%20with%20laptop%20and%20credit%20card%20on%20a%20clean%20desk%2C%20soft%20daylight%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=news-life-002&orientation=landscape',
    author: '本报记者 钱进',
    source: '爆料网消费观察',
    publishTime: '2026-10-11 15:10',
    views: 43600,
    tags: ['消费', '购物提醒', '生活'],
    hot: false,
    content: [
      '随着消费旺季临近，各类促销活动密集上线。为保护消费者权益，多部门联合发布消费提示，提醒公众理性看待优惠，警惕“先涨后降”、虚假宣传、预售不退等常见套路。',
      '提示指出，消费者在下单前应仔细阅读商品详情与退换货规则，留意价格变动，避免因冲动消费而后悔。对于需要预付定金的商品，要特别关注尾款支付时间与退款条件。',
      '此外，消费者应通过正规平台和商家购物，谨慎点击来源不明的链接与二维码，保护好个人信息与支付密码。购物凭证、聊天记录、物流信息等建议妥善留存，以备维权之需。',
      '相关部门表示，将持续加强市场监管，对侵害消费者权益的行为依法依规处理，营造放心消费的环境。',
    ],
  },
  {
    id: 'life-003',
    title: '秋日出游热度攀升，短途周边游成主流选择',
    summary:
      '秋高气爽，短途周边游成为许多家庭的首选。近郊赏秋、乡村采摘、城市漫步等玩法受到青睐，旅游市场持续回暖。',
    category: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20lifestyle%20photograph%20of%20a%20scenic%20autumn%20countryside%20trail%20with%20golden%20trees%20and%20mountains%2C%20warm%20sunlight%2C%20clean%20composition%2C%20muted%20warm%20tones%2C%20high%20detail&width=1200&height=800&seq=news-life-003&orientation=landscape',
    author: '本报记者 郑好',
    source: '爆料网旅游频道',
    publishTime: '2026-10-10 16:20',
    views: 39900,
    tags: ['旅游', '周边游', '生活'],
    hot: false,
    content: [
      '秋高气爽，正是出游的好时节。多个旅游平台的预订数据显示，短途周边游热度持续攀升，成为不少家庭周末休闲的首选。近郊赏秋、乡村采摘、城市漫步等玩法尤其受到欢迎。',
      '与长途旅行相比，周边游时间灵活、成本可控，也更适合亲子和朋友结伴出行。不少景区顺势推出主题市集、手作体验等活动，丰富游客的游玩内容。',
      '业内人士建议，出行前应提前查询天气与交通状况，合理规划路线，避开高峰时段。选择乡村民宿或农家乐时，可通过官方渠道预订，注意查看评价与退改规则。',
      '旅游消费的回暖也带动了地方特色产品的销售，不少乡村借势把“流量”转化为“留量”，推动农文旅融合发展。',
    ],
  },
  {
    id: 'life-004',
    title: '中小学课后服务升级，增设体育与艺术素养课程',
    summary:
      '多地中小学课后服务持续升级，在作业辅导之外增设体育、艺术、科技等素养课程，帮助学生全面发展。',
    category: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20lifestyle%20photograph%20of%20a%20bright%20classroom%20with%20children%20painting%20and%20building%20models%20after%20school%2C%20soft%20daylight%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=news-life-004&orientation=landscape',
    author: '本报记者 唐糖',
    source: '爆料网教育观察',
    publishTime: '2026-10-09 14:00',
    views: 36700,
    tags: ['教育', '课后服务', '生活'],
    hot: false,
    content: [
      '多地中小学课后服务持续升级，在原有的作业辅导基础上，进一步增设体育、艺术、科技、阅读等素养类课程，让学生在放学后能有更丰富的选择。',
      '记者在一所学校看到，课后服务时段里，操场上孩子们在练习足球与跳绳，教室里则开设了绘画、书法、机器人搭建等社团活动。校方表示，课程设置充分考虑了学生的兴趣差异与成长需求。',
      '为保障服务质量，不少学校引入了专业机构与志愿力量参与授课，并建立了课程评价机制，定期收集学生和家长的反馈进行调整。',
      '教育专家认为，课后服务的价值不仅在于“看护”，更在于为孩子们提供发现兴趣、锻炼能力的机会，家庭与学校应形成合力，共同呵护学生成长。',
    ],
  },
  {
    id: 'life-005',
    title: '食品安全监督抽检结果公布，合格率保持高位',
    summary:
      '最新一期食品安全监督抽检结果公布，整体合格率保持高位，监管部门对不合格产品已依法处置，并提示消费者注意选购要点。',
    category: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20fresh%20vegetables%20and%20fruits%20neatly%20arranged%20in%20a%20clean%20market%20stall%2C%20soft%20daylight%2C%20clean%20composition%2C%20fresh%20natural%20tones%2C%20high%20detail&width=1200&height=800&seq=news-life-005&orientation=landscape',
    author: '本报记者 吴桐',
    source: '爆料网食品安全栏目',
    publishTime: '2026-10-09 10:30',
    views: 33100,
    tags: ['食品安全', '消费', '生活'],
    hot: false,
    content: [
      '最新一期食品安全监督抽检结果公布，抽检覆盖粮食加工品、肉制品、乳制品、蔬菜水果等多个品类，整体合格率保持高位，反映出食品安全形势总体稳定向好。',
      '对抽检中发现的不合格产品，监管部门已第一时间责成生产经营者下架、召回，并依法依规进行处置。相关信息也同步向社会公开，接受公众监督。',
      '消费者在选购食品时，应注意查看生产日期、保质期与生产许可信息，尽量选择正规渠道购买，避免购买来源不明、包装破损的产品。生鲜食材应妥善冷藏，尽快食用。',
      '监管部门表示，将持续加大重点领域、重点时段的抽检力度，压紧压实企业主体责任，守护群众“舌尖上的安全”。',
    ],
  },
  {
    id: 'life-006',
    title: '智能家居加速入户，生活便利与隐私保护需兼顾',
    summary:
      '随着技术普及，智能家居设备加速进入寻常百姓家。专家提醒，在享受便利的同时，也要重视网络与隐私安全。',
    category: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20lifestyle%20photograph%20of%20a%20modern%20living%20room%20with%20smart%20home%20devices%20and%20ambient%20lighting%2C%20soft%20evening%20glow%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=news-life-006&orientation=landscape',
    author: '本报记者 林间',
    source: '爆料网科技生活',
    publishTime: '2026-10-08 17:40',
    views: 30500,
    tags: ['智能家居', '科技', '生活'],
    hot: false,
    content: [
      '随着技术不断普及，智能音箱、扫地机器人、智能门锁等设备加速进入寻常百姓家，从照明、安防到家电控制，智能家居正在悄然改变人们的生活方式。',
      '不少用户反映，设备联动后，回家前提前开空调、出门后自动关闭灯光等场景确实带来了便利。与此同时，设备之间互联互通、统一控制的需求也越来越突出。',
      '专家提醒，智能家居在带来便利的同时，也涉及网络与隐私安全。用户在选购时应关注品牌资质与数据加密能力，及时修改默认密码，定期更新固件，避免设备被非法控制。',
      '业内人士建议，消费者应根据自身实际需求理性选购，避免盲目追新。真正的智能，是让技术服务于生活，而不是给生活增添负担。',
    ],
  },
];